// @flow
import type {Action} from '../../../state/types'

export type SetErrorPayload = {
  error: ?string,
}

const id = 'session/SET_ERROR'

export const setError = (error: ?string): Action<SetErrorPayload> => ({
  type: id,
  payload: {
    error,
  }
})

setError.id = id
